<mat-form-field [formGroup]="parentForm" [appearance]="appearance" [color]="color">
  <mat-label>{{label}}</mat-label>
  <textarea matInput placeholder="{{placeholder}}" [readonly]="readonly" formControlName="{{name}}" [rows]="rows" (blur)="blur($event)">
    <ng-content></ng-content>
  </textarea>
  @if (!fieldValid) {
    <mat-error>{{errorMessage}}</mat-error>
  }
</mat-form-field>
